import * as React from 'react';
import {
  Container,
  Box,
  Typography,
  Paper
} from '@mui/material';
import { apiUrlPrefix } from '../../../config';
import { useMediaQuery } from "@mui/system";
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Avatar } from '@mui/material';
import ChangeProfilePictureWidget from './ChangeProfilePictureWidget';
import ChangePassword from '../Components/profile/ChangePassword';
import BlockList from './BlockList';
import HeaderBar from '../Components/Static/HeaderBar';
import useStore from '../state-files/zustondStoreStates';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Information from '../Components/profile/Information';
import Pepeha from '../Components/profile/Pepeha';

const ProfileScreen = ({ }) => {
  const isMobile = useMediaQuery('(max-width:1300px)');
  const [error, setError] = React.useState(null);

  const [passwordChanged, setPasswordChanged] = React.useState(false);
  const [selected, setSelected] = React.useState(0);
  const queryClient = useQueryClient(); // Access React Query's client
  const { isLoggedIn, setIsLoggedIn } = useStore();
  const { setCommunityId } = useStore();
  const navigate = useNavigate();

  //Checks if the user is logged in
  const selectedItem = {
    paddingTop: 1,
    paddingBottom: 1,
    backgroundColor: 'rgba(40, 165, 52, 0.5)',
    color: '#FFFFFF',
    boxSizing: 'border-box',
    width: '95%',
    pl: 2,
    cursor: 'pointer'
  };

  const nonSelectedItem = {
    paddingTop: 1,
    paddingBottom: 1,
    boxSizing: 'border-box',
    width: '95%',
    cursor: 'pointer'
  }

  React.useEffect(() => {
    if (setPasswordChanged) {
      const timer = setTimeout(() => {
        // Assuming 'setSetPasswordChanged' is your state setter function
        setPasswordChanged(false);
      }, 5000); // 5000 milliseconds = 5 seconds

      // Cleanup the timer if the component unmounts
      return () => clearTimeout(timer);
    }
  }, [setPasswordChanged]);

  // This EFFECT handles the actual redirection
  React.useEffect(() => {
    if (!isLoggedIn) {
      navigate('/', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  // This EARLY RETURN stops the rest of the code from running
  if (!isLoggedIn) {
    return null;
  }

  const deleteAccount = async () => {
    const userId = localStorage.getItem('userId');

    const apiUrl = apiUrlPrefix + "MongoDb/ScheduleDeletion";

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // Ensure we are sending { "userId": "675a..." }
        body: JSON.stringify({ userId: userId }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage);
      }

      localStorage.removeItem('refreshToken');
      localStorage.removeItem('refreshTokenExpiry');
      localStorage.removeItem('userId');
      localStorage.removeItem('username');
      setIsLoggedIn(false);
      return '200';

    } catch (error) {
      return 'error';
    }
  };



  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <HeaderBar isLoggedIn={true} />
      <Container>
        <Paper sx={{
          display: 'flex',
          flexDirection: 'column',
          height: 'fit-content',
          width: '100%',
          padding: 2,
          flex: 1
        }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, mb: 4 }}>
            <Avatar
              src={localStorage.getItem('profilePicture') || ""}
              alt="ProfilePicture"
              sx={{
                width: { xs: '80px', sm: '150px' },
                height: { xs: '80px', sm: '150px' },
              }}
            />
            <Typography fontSize={{ xs: "24px", sm: "36px" }}>{localStorage.getItem('username')}</Typography>
          </Box>
          {/*




                  User Settings




          */}
          <Box sx={{ display: 'flex', flexDirection: { xs: 'row', md: 'row' }, justifyContent: 'left', gap: { xs: 1, md: 0 } }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'left', flex: 1, textAlign: 'left', maxWidth: '33%', borderRight: '1px solid black' }}>
              <Typography fontSize={"24px"}>User settings:</Typography>
              <Typography
                id="userInfoButton"
                variant="contained"
                color="none"
                fontSize={"18px"}
                onClick={() => {
                  setSelected(0);
                }}
                style={{ boxShadow: 'none', cursor: 'pointer' }}
                sx={{ ...(selected === 0) ? selectedItem : nonSelectedItem }}
              >
                User Information
              </Typography>

              <Typography
                id="pepehaButton"
                variant="contained"
                color="none"
                fontSize={"18px"}
                onClick={() => {
                  setSelected(4);
                }}
                style={{ boxShadow: 'none', cursor: 'pointer' }}
                sx={{ ...(selected === 4) ? selectedItem : nonSelectedItem }}
              >
                Pepeha/ Genealogical Connections
              </Typography>

              <Typography
                id="blockListButton"
                variant="contained"
                color="none"
                fontSize={"18px"}
                onClick={() => { setSelected(1); }}
                style={{ boxShadow: 'none', cursor: 'pointer' }}
                sx={{ ...(selected === 1) ? selectedItem : nonSelectedItem }}
              >
                Block List
              </Typography>

              {/* 
                
                
                
                    Changing password
                    
                    


              */}
              <Typography fontSize={"18px"} variant="outlined" onClick={() => { setSelected(2); }} sx={{ ...(selected === 2) ? selectedItem : nonSelectedItem }}>
                Change Password
              </Typography>

              <ChangeProfilePictureWidget username={localStorage.getItem('username')}
                selectedItem={selectedItem} nonSelectedItem={nonSelectedItem} selected={selected} setSelected={setSelected} />

              <Typography fontSize={"18px"} variant="outlined" onClick={() => { deleteAccount() }} sx={{ nonSelectedItem, color: 'red', cursor: 'pointer' }}>
                Delete account
              </Typography>
            </Box>
            {/*





                  Ancestry
                  Mobile goes below the user settings, web goes to the side




          */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '50%' }}>
              <Information selected={selected} />
              <BlockList selected={selected} />
              
              {passwordChanged && (
                <Typography fontSize={'18px'} sx={{ color: "green" }}>Password changed successfully</Typography>
              )}
              <ChangePassword selectedItem={selectedItem} nonSelectedItem={nonSelectedItem} error={error} setError={setError} setPasswordChanged={setPasswordChanged}
                selected={selected} setSelected={setSelected} />
              
              <Pepeha selected={selected} />


            </Box>
          </Box>
        </Paper>

        {isMobile ? (
          <Box sx={{
            flex: 1,
            display: 'flex',          // This "turns on" the centering powers
            flexDirection: 'row',
            alignItems: 'center',     // Centers horizontally
            justifyContent: 'center',  // Centers vertically
            width: '100%'
          }}>
            {/*<a href="https://play.google.com/store/apps/details?id=com.tamab.roopuwhakatau">
              <img
                alt='Get it on Google Play'
                src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'
                style={{ width: '200px' }}
              />
            </a>*/}
          </Box>
        ) : null}
      </Container>
    </div>
  );
};

export default ProfileScreen;